import { BookmarksDrawer as View } from "ui-components";

import { useCloseMapTool, useBookmarksList } from "~map-view/states";

export const BookmarksDrawer = () => {
	const closeMapTool = useCloseMapTool();

	const bookmarksList = useBookmarksList();

	return (
		<View
			onClose={closeMapTool}
			bookmarksList={bookmarksList}
		/>
	);
};
